<template>
  <div class="input-wrapper">
    <input
      type="text"
      placeholder="Name your group*"
      @input="setFirstName($event.target.value)"
      :value="name.firstName"
      class="title"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters("addNew", {
      name: "getName"
    })
  },
  methods: {
    ...mapMutations("addNew", {
      setFirstName: "setFirstName"
    })
  }
};
</script>
